var Util = UIkit.util;
window.theme = window.theme || {};
theme.RingSet = (function () {

    function RingSet(container) {

        var $container = (this.$container = Util.$(container));
        var sectionId = Util.data($container, "section-id");

        this.settings = {
            namespace: '.slideshow-' + sectionId,
            sectionId: sectionId
        }

        this.variants = [];
        this.bundleItemsObjects = [];

        this.selectors = {

            addToCart: '[data-add-to-cart]',
            addToCartText: '[data-add-to-cart-text]',
            productForm: '[data-product-form]',
            regularPrice: '[data-regular-price]',
            salePrice: '[data-sale-price]',
            priceContainer: '.price',
            whishlistLink: '[data-wishlist-link]',
            bundlePrice: ".price-box [data-regular-price]",

            cartPopup: '[data-cart-popup]',
            cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
            cartPopupProductDetails: '[data-cart-popup-product-details]',
            cartPopupQuantity: '[data-cart-popup-quantity]',
            cartPopupTitle: '[data-cart-popup-title]',
            cartPopupWrapper: '[data-cart-popup-wrapper]',

            productSlideShow: '.single-product-slider',

            // Selectors for individual products in the ringset
            bundleItem: '.bundle-item', // Context
            originalSelectorId: '[data-bundle-item-variants]',
            singleOptionSelector: '.single-option-selector-' + sectionId
        }


        this.$addToCart = Util.$(this.selectors.addToCart, $container);
        this.$addToCartText = Util.$(this.selectors.addToCartText, this.$addToCart);
        this.$shopifyPaymentButton = Util.$(this.selectors.shopifyPaymentButton, $container);

        this.$bundlePrice = Util.$(this.selectors.bundlePrice, $container);
        this.$bundleItems = Util.$$(this.selectors.bundleItem, $container);


        // Load required data

        if (Util.$('#ProductJson-product-template') == null) {
            return false;
        }

        // Data about bundle
        var jsonStr = document.getElementById('ProductJson-product-template').innerHTML, o = {};
        this.productSingleObject = JSON.parse(jsonStr);

        if (Util.$('#BundleJson-0') == null) {
            return false;
        }
        var bundleItemsCount = Util.$$('[id^="BundleJson-"]').length;

        // Load data about bundle items
        for (var i = 0; i < bundleItemsCount; i++) {
            jsonStr = document.getElementById('BundleJson-' + i).innerHTML;
            o = JSON.parse(jsonStr);

            //Meta data
            jsonStr = document.getElementById('BundleJsonMeta-' + i).innerHTML;
            o.metafields = JSON.parse(jsonStr);

            // Push Entire object
            this.bundleItemsObjects.push(o);
        }

        // Init
        this._initSlideshow();
        this._initVariants();
        this._initAddToCart();
        this._whishlistButtonInit();
    }

    RingSet.prototype = _.assignIn({}, RingSet.prototype, {

        _checkIfBundleInCart: function () {

            var state = false;
            var bundleSKU = this.productSingleObject.variants[0].sku;

            if (Util.$('#CartContainer [data-ringset-group="' + bundleSKU + '"]')) {
                state = true;
                var modal = [
                    '<div class="uk-position-top uk-width-1-1 uk-z-index-10">',
                    '<div class="uk-alert uk-alert-success uk-alert-yellow" data-uk-alert>',
                    '<div class="uk-flex uk-flex-wrap uk-flex-between uk-flex-middle">',
                    '<div>',
                    '<p>Sorry, but it is not possible to order the same ring set twice in the same order. To order the same ring set again, please checkout and then place a separate order, or <a href="/pages/contact-us">contact us</a> to process your order.</p>',
                    '</div>',
                    '<div class="uk-margin-small-top">',
                    '<a href="/cart" class="uk-button uk-button-text"><span>View bag and checkout</span></a>&nbsp;&nbsp;&nbsp;&nbsp;',
                    '<a href="#" data-uk-close class="uk-alert-close" arial-label="Close Popup"></a>',
                    '</div>',
                    '</div>',
                    '</div>',
                    '</div>'
                ].join("");

                Util.prepend(Util.$(".product-section-wrapper"), modal);
                $site.buttonAnims(".uk-alert");
                UIkit.scroll('#top').scrollTo('#top');
            }
            this._handleButtonLoadingState(state);
            return state;
        },

        _initSlideshow: function () {
            var opts = {
                ratio: "1:1",
                animation: "uk-animation-slide-left"
            }

            if (Util.width(window) >= $site.breakpoint) {
                opts.draggable = false;
                opts.animation = "fade";
            }
            // single-product-slider
            UIkit.slideshow(Util.$(".single-product-slider"), opts);
        },


        /**
         * Add to cart button
         */
        _initAddToCart: function () {

            var self = this,
                callback = function () {
                    var modal = [
                        '<div class="uk-position-top uk-width-1-1 uk-z-index-10">',
                        '<div class="uk-alert uk-alert-success uk-alert-yellow" data-uk-alert>',
                        '<div class="uk-flex uk-flex-wrap uk-flex-between uk-flex-middle">',
                        '<div>',
                        '<p>You added Ring Set to your shopping bag.&nbsp;&nbsp;&nbsp;&nbsp;</p>',
                        '</div>',
                        '<div>',
                        '<a href="/cart" class="uk-button uk-button-small uk-button-outline"><span>View bag and checkout</span></a>&nbsp;&nbsp;&nbsp;&nbsp;',
                        '<a href="#" data-uk-close class="uk-alert-close" arial-label="Close Popup"></a>',
                        '</div>',
                        '</div>',
                        '</div>',
                        '</div>'
                    ].join("");

                    Util.prepend(Util.$(".product-section-wrapper"), modal);
                    $site.buttonAnims(".uk-alert");
                    UIkit.scroll('#top').scrollTo('#top');
                };

            Util.on(Util.$(this.selectors.productForm, this.$container), "submit", function (evt) {

                evt.preventDefault();

                if (Util.hasAttr(this.$addToCart, "aria-disabled")) {
                    return;
                }

                // Disable the addToCart and dynamic checkout button while
                // request/cart popup is loading and handle loading state
                if (this._checkIfBundleInCart()) {
                    return;
                }

                // Validate engraving
                var items = Util.$$("[data-bundle-item-variants]");
                var valid = true, items, product_id, checkbox, text;

                for (var i = 0; i < items.length; i++) {
                    item = items[i];
                    product_id = Util.data(item, "product-id");
                    text = '';

                    checkbox = Util.$("#engraving_cb" + product_id);

                    if (Util.$("#engraving-text" + product_id + " [data-engraving-text]")) {
                        text = Util.$("#engraving-text" + product_id + " [data-engraving-text]").value.trim();
                    }

                    //Find out if this ring has engraving
                    if (checkbox != null && checkbox.checked && text == "") {
                        valid = false;
                        break;
                    }
                }

                if (!valid) {
                    theme.Utility.dialog("Engraving text is missing.", "uk-alert-warning");
                    return false;
                }

                this._handleButtonLoadingState(true);
                var $form = Util.$(this.selectors.productForm, this.$container);
                var form_data = self.normalizeProductFormData($form, this.bundleItemsObjects);

                this._addAllItemsToCart(form_data, function (response) {
                    Util.trigger(Util.$("body"), 'updateCart', {data: response});
                    callback()
                });
            }.bind(this));
        },


        /**
         * Recursive function to add all products into the cart
         */
        _addAllItemsToCart: function (products, callback) {

            var p = products, added = [];
            Shopify.queue = products;

            if (products.length == 0) {
                return;
            }

            Shopify.moveAlong = function () {
                if (Shopify.queue.length > 0) {

                    var request = Shopify.queue.pop();

                    console.log("REQUEST", request);

                    var data = {
                        id: request.id,
                        quantity: 1,
                        form_type: "product",
                        utf8: "%E2%9C%93"
                    };

                    for (prop in request.properties) {
                        data['properties[' + prop + ']'] = request.properties[prop];
                    }

                    data = theme.Utility.serialize(data);

                    var params = {
                        method: "POST",
                        data: data,
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    };

                    Util.ajax("/cart/add.js", params)
                        .then(function (xhr) {
                            // Add item to Popup cart
                            added.push(JSON.parse(xhr.response));
                            Shopify.moveAlong();
                        })
                        .catch(function () {
                            if (Shopify.queue.length) {
                                Shopify.moveAlong()
                            }
                            console.log("CATCH ERROR!", arguments);
                        });
                } else {
                    callback(added);
                }
            }
            Shopify.moveAlong();
        },


        /**
         * @param form All fields from the form
         * @param p Product JSON
         * @returns {[]}
         */
        normalizeProductFormData: function (form, p) {

            var serialized = [],
                engravings = [],
                types = ["metal", "gem", "enamel"],
                checkbox,
                field,
                bundle_sku = Util.data(Util.$("[data-product-related-code]", this.$container), "product-related-code");

            var gift_wrap = Util.$("#gift-wrapping");


            // Loop through each field in the form
            for (var i = 0; i < form.elements.length; i++) {

                field = form.elements[i];

                // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
                if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

                o = {};

                if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                    if (field.name == 'id[]') {
                        var product_id = Util.data(field, "data-product-id"),
                            engraving_text = "",
                            checked, key, wr,
                            o = {
                                id: field.value,
                                properties: {
                                    "Part of": bundle_sku,
                                    "_ringset_sku": bundle_sku
                                }
                            };

                        var bundleItem = null;

                        // Assign product properties
                        if (p.length > 0) {
                            bundleItem = p.filter(function (a) {
                                return a.id == product_id;
                            });

                            if (bundleItem.length == 1) {

                                var meta = bundleItem[0]['metafields'];
                                if (typeof meta['specs.ring_width'] !== "undefined") {
                                    o.properties["Ring Width"] = meta['specs.ring_width'];
                                }

                                /* Get / Set product's main collection */
                                var collection = bundleItem[0].tags.filter(function (item) {
                                    return item.indexOf("Collection-") !== -1
                                });
                                if (collection.length > 0) {
                                    collection = collection[0].replace("Collection-", "");
                                    o.properties["_collection"] = encodeURIComponent(collection);
                                }

                                for (var t in types) {
                                    key = types[t].charAt(0).toUpperCase() + types[t].slice(1);

                                    for (var ii = 0; ii < bundleItem[0].tags.length; ii++) {
                                        if ((bundleItem[0].tags[ii].indexOf('Parent' + key + "-") == -1) && bundleItem[0].tags[ii].indexOf(key + "-") > -1) {
                                            o.properties[key] = encodeURIComponent(bundleItem[0].tags[ii].replace(key + "-", ""));
                                        }
                                    }
                                }
                            }
                        }

                        if (gift_wrap.checked) {
                            o.properties["_wrapped_bundle"] = true;
                        }

                        if (Util.$("#engraving-text" + product_id + " [data-engraving-text]")) {
                            engraving_text = Util.$("#engraving-text" + product_id + " [data-engraving-text]").value,
                                checkbox = Util.$("#engraving_cb" + product_id);

                            //Find out if this ring has engraving
                            if (checkbox.checked && engraving_text != "") {
                                o.properties["Engraving"] = encodeURIComponent(engraving_text);
                            }
                        }

                        serialized.push(o);
                    }

                    if (field.name == 'engraving' && field.checked) {
                        var parentbox = field.parentNode.parentNode,
                            text = Util.$("[data-engraving-text]", parentbox).value,
                            product_id = field.getAttribute("data-related-product"),
                            engraving = {};

                        if (text != "") {
                            engraving.id = field.value;
                            engraving.properties = {
                                "Bundle Engraving": "✓"
                            };
                            engravings.push(engraving);
                        }
                    }
                } // If
            } // For Loop

            if (!_.isEmpty(engravings)) {
                Array.prototype.push.apply(serialized, engravings);
            }

            if (gift_wrap.checked) {
                var id = Util.data(gift_wrap, 'data-product-id');
                var o = {
                    id: id,
                    properties: {
                        "Bundle Wrap": "✓"
                    }
                };
                Array.prototype.push.apply(serialized, [o]);
            }
            return serialized;
        },


        /**
         * @param {*} isLoading
         */
        _handleButtonLoadingState: function (isLoading) {
            if (isLoading) {
                Util.attr(this.$addToCart, 'aria-disabled', true);
                Util.attr(this.$shopifyPaymentButton, 'disabled', true);
            } else {
                Util.removeAttr(this.$addToCart, "aria-disabled");
                Util.removeAttr(this.$shopifyPaymentButton, "disabled");
            }
        },


        _initVariants: function () {

            var options, item;

            for (var i in this.$bundleItems) {

                item = this.$bundleItems[i];

                options = {
                    $container: item,//this.$container,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.bundleItemsObjects[i]
                };

                item.variantData = new theme.Variants(options);

                // Bind Events
                Util.on(item, 'variantChange', this._updateAvailability.bind(this));
                Util.on(item, 'variantUpdated', this._updateEngraving.bind(this));
                Util.on(item, 'variantPriceChange', this._updatePrice.bind(this));
                Util.on(item, 'variantUpdated', this._updateBundlePrice.bind(this));
            }

            this._updateBundlePrice();
        },


        _updateAvailability: function (evt) {
        },


        /**
         * Update variant id that on certain tag that are used to connect engraving with rings
         *
         * @param {*} evt
         */
        _updateEngraving: function (evt) {

            var variant = evt.detail.variant,
                currentProduct = this.$bundleItems.filter(function (item) {
                    return item.variantData.currentVariant.id == variant.id
                })[0];

            // Selectors
            var original = Util.$(this.selectors.originalSelectorId, currentProduct);
            var fields = Util.$$("[data-related-product]", currentProduct);

            original.setAttribute('data-variant-id', variant.id);
            Util.each(fields, function (item) {
                item.setAttribute('data-related-product', variant.id);
            });
        },


        _updateBundlePrice: function (evt) {
            var total = 0, item, v;
            for (var i in this.$bundleItems) {
                item = this.$bundleItems[i];
                v = item.variantData;
                total = total + v.currentVariant.price;
            }
            Util.html(this.$bundlePrice, theme.Currency.formatMoney(total, theme.moneyFormat));
        },


        /**
         *  Update bundle single item price
         * @param {} evt
         */
        _updatePrice: function (evt) {

            // update single product price
            // update Total price

            var variant = evt.detail.variant,
                $target = evt.target,
                $regularPrice = Util.$(this.selectors.regularPrice, $target),
                $salePrice = Util.$(this.selectors.salePrice, $target);


            // Unavailable
            if (!variant) {
                Util.addClass($target, 'product-unavailable');
                return;
            }

            // On sale
            if (variant.compare_at_price > variant.price) {
                Util.html($regularPrice, theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                Util.html($salePrice, theme.Currency.formatMoney(variant.price, theme.moneyFormat));
                Util.addClass($target, 'product-on-sale');
            } else {
                // Regular price
                Util.html($regularPrice, theme.Currency.formatMoney(variant.price, theme.moneyFormat));
            }
        },


        _whishlistButtonInit: function () {

            var $link = Util.$(this.selectors.whishlistLink, this.$container);

            function swymCallbackFn() {
                _swat.fetchWrtEventTypeET(fetchCallbackFn, 4);
            }

            function fetchCallbackFn(products) {
                var activeProductId = SwymPageData.empi,
                    activeVariantId = SwymPageData.epi;
                var isInWishlist = products.find(function (p) {
                    return p.empi == activeProductId && p.epi == activeVariantId;
                });
                if (isInWishlist) {
                    $link.setAttribute("disabled", true);
                    $link.innerHTML = "Added to Wish List";
                } else {
                    Util.on($link, "click", function (e) {
                        var wishlistButton = e.target;
                        e.preventDefault();
                        if (SwymPageData) {
                            SwymPageData.et = 4;  // et 4 stands for wishlist event type
                            _swat.addToWishList(SwymPageData, function (e) {
                                wishlistButton.innerHTML = "Added to Wish List";
                                Util.addClass(wishlistButton, "uk-disabled");
                                Util.attr(wishlistButton, "disabled", true);
                            });
                        }
                    });
                }
            }

            if (!window.SwymCallbacks) {
                window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(swymCallbackFn);
        },
    });
    return RingSet;
})();